module.exports = __webpack_public_path__ + "img/图层10.11824232.png";